mainApp.component('discoveryResultsHistogram', {
    templateUrl: '/public/components/discovery/discovery-result-histogram.component.html',
    bindings: {
        buckets: '<',
        timeRange: '<',
        totalCount: '<',
        onTimeRangeChange: '&',
        onAddFilter: '&',
        onRemoveFilter: '&',
        onChangeFilter: '&',
        filters: '<'
    },
    controller: function(DiscoveryQueryService) {
        const ctrl = this;

        ctrl.colors = [
            '#f26c4f',
            '#fbaf5d',
            '#acd373',
            '#00bff3',
            '#5674b9',
            '#8560a8',
            '#f06eaa',
            '#c69c6d',
            '#009999',
            '#3cb878',
        ];

        ctrl.$onInit = function() {
            if (!ctrl.histogram) {
                ctrl.makeChart();
            }
        }

        ctrl.$onDestroy = function() {
            ctrl.histogram.clear();
        }

        ctrl.buildAllGraphs = function () {
            return [
                ctrl.buildGraphForCategory("Routing", ctrl.colors[0]),
                ctrl.buildGraphForCategory("Security",ctrl.colors[1]),
                ctrl.buildGraphForCategory("Connectivity",ctrl.colors[2]),
                ctrl.buildGraphForCategory("System",ctrl.colors[3]),
                ctrl.buildGraphForCategory("Sockets Management",ctrl.colors[4]),
            ]
        }

        ctrl.makeChart = function() {
            ctrl.histogram = AmCharts.makeChart("histogram", {
                type: "serial",
                fontFamily: 'Roboto',
                addClassNames: true,
                path: "/public/javascripts/external/amcharts/",
                theme: "new",
                pathToImages: "/public/javascripts/external/amcharts/images/",
                categoryField: "time",
                // "startDuration": 1,
                categoryAxis: {
                    gridAlpha: 0.15,
                    twoLineMode: true,
                    minPeriod: ctrl.timeRange.bucketDuration + 'fff',
                    parseDates: true,
                    dateFormats: [
                        {period:'fff', format:'JJ:NN:SS'},
                        {period:'ss', format:'JJ:NN:SS'},
                        {period:'mm', format:'JJ:NN'},
                        {period:'hh', format:'JJ:NN'},
                        {period:'DD', format:'MMM DD'},
                        {period:'WW', format:'MMM DD'},
                        {period:'MM', format:'MMM'},
                        {period:'YYYY', format:'YYYY'}]
                },
                chartCursor: {
                    cursorPosition: "mouse",
                    selectWithoutZooming: true,
                    categoryBalloonDateFormat: "YYYY/MM/DD JJ:NN:SS.QQQ"
                },
                chartScrollbar: {
                    enabled: false
                },
                legend: {
                    horizontalGap: 0,
                    position: "bottom",
                    useGraphSettings: true,
                    markerSize: 10,
                    equalWidths: false,
                },
                trendLines: [],
                graphs: ctrl.buildAllGraphs(),
                valueAxes: [
                    {
                        stackType: "regular",
                        stackByValue: true,
                        id: "ValueAxis-1",
                    }
                ],
                allLabels: [],
                balloon: {},
                listeners: [
                    {
                        event: "init",
                        method: ctrl.afterInit
                    }]
            });
        }

        ctrl.buildGraphForCategory = function(category, color) {
            return {
                fillAlphas: 1,
                id: category + "Graph",
                title: category,
                type: "column",
                dateFormat: "JJ, MMM DD, YYYY",
                valueField: category,
                category: category,
                lineColor: color
            }
        }

        ctrl.$onChanges = function(changes) {
            if (changes['buckets'] && changes['buckets'].currentValue) {
                if (!ctrl.histogram) {
                    ctrl.makeChart();
                }
                ctrl.histogram.dataProvider = ctrl.buckets;
                ctrl.histogram.validateData();
                ctrl.histogram.categoryAxis.minPeriod = ctrl.timeRange.bucketDuration + 'fff';
            }

            if (changes['filters'] && changes['filters'].currentValue) {

                let hidden = false;
                let visibleType;
                changes['filters'].currentValue.forEach(f => {
                    if (f.field === 'event_type' && f.operator === 'is') {
                        hidden = true;
                        visibleType = f.value;
                    }
                });

                let mustMatchPhraseExists = false;

                if (!ctrl.histogram)
                    ctrl.makeChart();

                ctrl.histogram.graphs.forEach(g => {
                    g.hidden = hidden;
                    if (g.title === visibleType) {
                        g.chart.lastClicked = g.title;
                        g.chart.allVisible = false;
                        g.hidden = false;

                        mustMatchPhraseExists = true;
                    }
                });

                changes['filters'].currentValue.forEach(f => {
                    if (f.field === 'event_type' && f.operator === 'is_not') {
                        ctrl.histogram.graphs.forEach(g => {
                            if (g.title === f.value) {
                                if (!mustMatchPhraseExists)
                                    g.chart.lastClicked = g.title;

                                g.chart.allVisible = false;
                                g.hidden = true;
                            }
                        });
                    }
                });
            }
        }

        ctrl.afterInit = function(chart) {
            chart = chart.chart;
            chart.chartCursor.addListener("selected", ctrl.handleZoom);

            chart.addListener("clickGraphItem", function (event) {
                ctrl.timeRange.from = new Date(event.item.category.getTime() - ctrl.data.histogramInterval);
                ctrl.timeRange.to = new Date(event.item.category.getTime() + ctrl.data.histogramInterval);
            });
            chart.chartCursor.addListener("onShowCursor", function (event) {
                event.chart.chartDiv.style.cursor = "zoom-in";
            });
            chart.chartCursor.addListener("onHideCursor", function (event) {
                event.chart.chartDiv.style.cursor = "default";
            });

            chart.legend.addListener("hideItem", ctrl.hideOthers);
            chart.legend.addListener("showItem", ctrl.hideOthers);
        }

        ctrl.hideOthers = function(event) {
            var currentGraph = event.dataItem;
            var hidden = true;
            // check if we clicked on this graph before and if all the other graphs are visible.
            // if we clicked on this graph before and the other graphs are invisible,
            // make them visible, otherwise default to previous behavior

            if (event.chart.lastClicked === currentGraph.title && event.chart.allVisible === false) {
                hidden = false;
                event.chart.allVisible = true;

                ctrl.onRemoveFilter({
                    deleted: {
                        field: 'event_type',
                        operator: 'is',
                        value: event.dataItem.category
                    }
                });
            }
            else {
                event.chart.allVisible = false;
                ctrl.onChangeFilter({
                    prevItem: {
                        field: 'event_type',
                        operator: 'is',
                        value: event.chart.lastClicked
                    },
                    field: 'event_type',
                    operator: 'is',
                    value: event.dataItem.category
                });
            }
            event.chart.lastClicked = currentGraph.title; // keep track of the current one we clicked

            currentGraph.hidden = false; // force clicked graph to stay visible
            event.chart.graphs.forEach(function(graph) {
                if (graph.title !== currentGraph.title) {
                    graph.hidden = hidden;  //set the other graph's visibility based on the rules above
                }
            });
            // update the chart with newly set hidden values
            event.chart.validateNow();
        }

        ctrl.handleZoom = function(event) {
            ctrl.onTimeRangeChange({from: Math.min(event.start, event.end), to: Math.max(event.start, event.end)});
            return false;
        }
    }
});